import { KText } from '@/ui-library/components/text';
import { Alert, AlertIcon } from '@chakra-ui/react';

export const EnrichmentInfo = () => {
  return (
    <Alert status="info" borderRadius="8px" bg="pastel-4-light">
      <AlertIcon alignSelf="normal" color="pastel-4-dark" />
      <KText mr="10px">
        We will attempt to enrich candidate's email before we kick off the Flow
      </KText>
    </Alert>
  );
};
